import { homeIndex } from '@/views/approvalCenter/api/index.js'
import { getTodoCount } from '@/views/approvalCenter/api'
import { checkTodoCount, checkDoneCount, checkCopyCount } from '@/views/approvalCenter/api'
const state = {
  homeTotal: {
    needApproveNum: 0, // 待审批数
    copyToMe: 0, // 抄送给我
    approveNum: 0, // 审批数
    approveAvgTime: 0 // 审批耗时
  },
  todo: {},
  waitingList: [],
  doneList: [],
  copyList: []
}

const mutations = {
  SET_HOMETOTLE: (state, payload) => {
    state.homeTotal = payload
  },
  SET_TODO: (state, payload) => {
    state.todo = payload
  },
  SET_WAITING: (state, payload) => {
    state.waitingList = payload
  },
  SET_DONE: (state, payload) => {
    state.doneList = payload
  },
  SET_COPY: (state, payload) => {
    state.copyList = payload
  },
  SET_LABELWIDTH: (state, width) => {
    state.labelWidth = width
  },
  DELETE_FORMITEM: (state, index) => {
    state.formItem.splice(index, 1)
  },
  SET_FORMITEM: (state, { index, val }) => {
    state.formItem[index] = val
  },
  SET_GUTTER: (state, width) => {
    state.gutter = width
  },
  RESET_STATE: (state) => {
    state.homeTotal = {
      needApproveNum: 0, // 待审批数
      copyToMe: 0, // 抄送给我
      approveNum: 0, // 审批数
      approveAvgTime: 0 // 审批耗时
    }
    state.todo = {}
    state.waitingList = []
    state.doneList = []
    state.copyList = []
  }
}

const actions = {
  set_hometotal: async({ commit }, payload) => {
    const res = await homeIndex()
    if (res.code === 200 && res.data) {
      commit('SET_HOMETOTLE', res.data)
    }
  },
  set_todo: async({ commit }, payload) => {
    const res = await getTodoCount()
    if (res.code === 200 && res.data) {
      commit('SET_TODO', res.data)
    }
  },
  set_waiting: async({ commit }, payload) => {
    const res = await checkTodoCount({ pageNum: 1, pageSize: 4, isIndex: 1 })
    if (res.code === 200 && res.data && res.data.list) {
      commit('SET_WAITING', res.data.list)
    }
  },
  set_done: async({ commit }, payload) => {
    const res = await checkDoneCount({ pageNum: 1, pageSize: 4, isIndex: 1 })
    if (res.code === 200 && res.data && res.data.list) {
      commit('SET_DONE', res.data.list)
    }
  },
  set_copy: async({ commit }, payload) => {
    const res = await checkCopyCount({ pageNum: 1, pageSize: 4, copyState: 0, isIndex: 1 })
    if (res.code === 200 && res.data && res.data.records) {
      commit('SET_COPY', res.data.records)
    }
  },
  set_labelWidth: ({ commit }, width) => {
    commit('SET_LABELWIDTH', width)
  },
  delete_formItem: ({ commit }, index) => {
    commit('DELETE_FORMITEM', index)
  },
  set_formItem: ({ commit }, payload) => {
    commit('SET_FORMITEM', payload)
  },
  set_gutter: ({ commit }, width) => {
    commit('SET_GUTTER', width)
  },
  relaod_view: ({ dispatch }) => {
    dispatch('set_hometotal')
    dispatch('set_copy')
    dispatch('set_done')
    dispatch('set_waiting')
    dispatch('set_todo')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

